export const participantConfig = [
  {
    key: 'participant.behaviorTracker',
    label: 'My Behavior Tracker',
    isExpandable: true,
    children: [],
    link: (params) => '/participant/my-behavior-tracker',
    linkedUrls: (params) => ['/participant/my-behavior-tracker', '/participant/contract'],
    isExpanded: false,
    queryParamKey: 'weekNumber'
  },
  {
    key: 'participant.journal',
    label: 'My e-Journal',
    isExpandable: true,
    children: [],
    link: (params) => '/participant/my-journal',
    linkedUrls: (params) => ['/participant/my-journal'],
    isExpanded: false,
    queryParamKey: 'weekNumber'
  },
  {
    key: 'participant.metrics',
    label: 'My Measurements',
    isExpandable: false,
    children: [],
    link: (params) => '/participant/my-metrics',
    linkedUrls: (params) => ['/participant/my-metrics'],
    isSelected: false
  },
  {
    key: 'participant.progress',
    label: 'My Progress',
    isExpandable: false,
    children: [],
    link: (params) => '/participant/my-progress',
    linkedUrls: (params) => ['/participant/my-progress'],
    isSelected: false
  },
  {
    key: 'participant.resourceHub',
    label: 'My Resource Hub',
    isExpandable: false,
    children: [],
    link: (params) => '/participant/resource-hub/resources-list',
    linkedUrls: (params) => ['/participant/resource-hub/resources-list', `/participant/resource-hub/resource-details/${params.resourceId}/${params.slug}`],
    isSelected: false
  },
  {
    key: 'participant.questionnaire',
    label: 'My Questionnaire',
    isExpandable: false,
    children: [],
    link: (params) => '/participant/questionnaires/my-questionnaires',
    linkedUrls: (params) => ['/participant/questionnaires/my-questionnaires', `/participant/questionnaires/take-questionnaires/${params.questionnaireId}`, `/participant/questionnaires/survey-questionnaires/${params.questionnaireId}`
    ],
    isSelected: false
  }
];
